<template>
  <v-layout row style="height: 100%">
    <v-dialog v-model="companyDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Company Code</v-card-title>
        <v-card-text>
          <p>Please enter your company code</p>
          <v-text-field
            label="Company Code"
            v-model="companyValue"
            autofocus
          >
          </v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="companyValue.length < 1" color="green darken-1" flat @click.native="setCompanyValue()">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-flex lg6 offset-lg3>
      <v-card height="100%" v-if="pinVisible">
        <p class="headline text-xs-center py-3">Please Enter Your PIN Code</p>
        <v-container fluid v-if="pinLength <= 4">
          <v-layout row wrap grid-list-xs class="text-xs-center px-5 py-1">
            <v-flex xs3>
              <v-icon medium :class="this.value.length > 0 ? 'green--text' : ''">{{ this.value.length > 0 ? 'radio_button_checked' : 'radio_button_unchecked' }}</v-icon>
            </v-flex>
            <v-flex xs3>
              <v-icon medium :class="this.value.length > 1 ? 'green--text' : ''">{{ this.value.length > 1 ? 'radio_button_checked' : 'radio_button_unchecked' }}</v-icon>
            </v-flex>
            <v-flex xs3>
              <v-icon medium :class="this.value.length > 2 ? 'green--text' : ''">{{ this.value.length > 2 ? 'radio_button_checked' : 'radio_button_unchecked' }}</v-icon>
            </v-flex>
            <v-flex xs3>
              <v-icon medium :class="this.value.length > 3 ? 'green--text' : ''">{{ this.value.length > 3 ? 'radio_button_checked' : 'radio_button_unchecked' }}</v-icon>
            </v-flex>
          </v-layout>
        </v-container>
        <v-container fluid v-else>
          <v-text-field
            label="PIN Code"
            v-model="value"
            type="password"
            :maxlength="pinLength"
            class="mx-6"
          ></v-text-field>
        </v-container>
        <v-layout row wrap grid-list-xs class="text-xs-center px-5 pb-5" style="touch-action: manipulation">
            <v-flex xs4>
              <v-btn class="primary" fab flat large @click="addDigit(1)">1</v-btn>
            </v-flex>
            <v-flex xs4>
              <v-btn class="primary" fab flat large @click="addDigit(2)">2</v-btn>
            </v-flex>
            <v-flex xs4>
              <v-btn class="primary" fab flat large @click="addDigit(3)">3</v-btn>
            </v-flex>
            <v-flex xs4>
              <v-btn class="primary" fab flat large @click="addDigit(4)">4</v-btn>
            </v-flex>
            <v-flex xs4>
              <v-btn class="primary" fab flat large @click="addDigit(5)">5</v-btn>
            </v-flex>
            <v-flex xs4>
              <v-btn class="primary" fab flat large @click="addDigit(6)">6</v-btn>
            </v-flex>
            <v-flex xs4>
              <v-btn class="primary" fab flat large @click="addDigit(7)">7</v-btn>
            </v-flex>
            <v-flex xs4>
              <v-btn class="primary" fab flat large @click="addDigit(8)">8</v-btn>
            </v-flex>
            <v-flex xs4>
              <v-btn class="primary" fab flat large @click="addDigit(9)">9</v-btn>
            </v-flex>
            <v-flex xs4>
            </v-flex>
            <v-flex xs4>
              <v-btn class="primary" fab flat large @click="addDigit(0)">0</v-btn>
            </v-flex>
            <v-flex xs4>
              <v-btn class="primary--text" fab flat large @click="removeDigit()"><v-icon>backspace</v-icon></v-btn>
            </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs12>
            <Notice-Alert></Notice-Alert>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
    <v-dialog v-model="recoveryModal" persistent max-width="290">
      <v-card>
        <template v-if="!recoveryOptions">
          <v-card-text class="my-0 pt-3 pb-0">
            <v-select
              prepend-icon="mdi-translate"
              label="Choose Language"
              :items="['English', 'Polskie', 'Română', 'Lietuvis']"
              v-model="maintLang"
            ></v-select>
          </v-card-text>
          <v-card-title class="headline" v-text="maintText[maintLang].title"></v-card-title>
          <v-card-text v-text="maintText[maintLang].para1"></v-card-text>
          <v-card-text>
            {{maintText[maintLang].para2preIcon}}
          <v-badge overlap color="green" style="margin-right:3px;">
            <v-icon slot="badge" dark small>add</v-icon>
            <v-icon
              color="grey darken-1"
              medium
            >
              receipt
            </v-icon>
          </v-badge>
            {{maintText[maintLang].para2postIcon}}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat @click="recoveryOptions = true">Next</v-btn>
          </v-card-actions>
        </template>
        <Recovery-Form v-else :pin="value"></Recovery-Form>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="signingIn"
        hide-overlay
        persistent
        width="300"
      >
        <v-card
          color="primary"
          dark
        >
          <v-card-text>
            Signing In
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    <v-snackbar
      v-model="unauthorised"
      color="error"
      multi-line
      :timeout="0">
      <v-icon large class="mr-4">error</v-icon>
      {{unauthorisedMsg}}
      <v-btn
        dark
        flat
        @click="unauthorised = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import axios from 'axios'
import * as firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/auth'
export default {
  props: ['company', 'emp'],
  data: () => ({
    value: '',
    companyValue: '',
    companyDialog: false,
    pinVisible: false,
    unauthorised: false,
    unauthorisedMsg: '',
    companyCharcodes: '',
    pinCharcodes: '',
    recoveryModal: false,
    recoveryOptions: false,
    maintLang: 'English',
    signingIn: false,
    maintText: {
      English: {
        title: 'Maintenance Mode',
        para1: 'The server is currently undergoing maintenance and functionality is limited to clocking in/out. Please use the folllowing options to submit your request.',
        para2preIcon: 'You will be able to attach expenses to a shift using this icon',
        para2postIcon: 'once the server is reachable again.'
      },
      Polskie: {
        title: 'SERWER W TRYBIE KONSERWACJI',
        para1: 'Serwer jest obecnie poddawany konserwacji I jego funkcjonalnosc jest ograniczona przy logowaniu do/z. Prosze uzyc nastepujacych opcji aby zatwierdzic Twoja prosbe.',
        para2preIcon: 'Bedziesz mogl dodac wszystkie rachunki ( wydatki ) do swojej zmiany uzywajac tej ikony',
        para2postIcon: 'tak szybko jak serwer bedzie ponownie dostepny.'
      },
      Română: {
        title: 'Modul de mentenanta',
        para1: 'In acest moment serverul este in modul de mentenanta. Functionalitatea de inregistrare in/out este limitata. Va rugam folositi urmatoarele optiuni pentru a va inregistra cererile.',
        para2preIcon: 'Veti avea posibilitatea sa atasati chitantele cu cheltuielite avute folosind icoana',
        para2postIcon: 'de indata ca serverul va fi functional iarasi.'
      },
      Lietuvis: {
        title: 'Prieziuros Rezimas',
        para1: 'Serveriui laikinai atliekama technine apziura, todel naudojimas yra ribotas norint isiregistruoti/issiregistruoti. Prasome naudotis zemiau pateikta parinktimi  norint pateikti uzklausa.',
        para2preIcon: 'Galesite prideti islaidas pamainos metu pasirinke piktograma',
        para2postIcon: 'kai tik serveris bus pasiekamas.'
      }
    },
    pinLength: 4
  }),
  created () {
    if (this.emp !== undefined && this.setCompany) {
      // console.log(atob(this.emp))
      // this.$store.dispatch('signUserIn', this.emp)
      // this.$store.dispatch('checkCompany', this.company)
      // localStorage.setItem('company', this.setCompany)
      // this.$router.push('/')
      let n = 0
      while (n < this.company.length) {
        this.companyCharcodes = this.companyCharcodes + '#' + this.company.charCodeAt(n)
        n++
      }
      n = 0
      while (n < this.emp.length) {
        this.pinCharcodes = this.pinCharcodes + '#' + this.emp.charCodeAt(n)
        n++
      }
      this.value = this.emp
      // this.submitPin()
    } else if (this.company) {
      this.$store.dispatch('checkCompany', this.company)
      this.pinVisible = true
      this.getPinLength()
    } else if (!this.setCompany || this.setCompany === 'undefined') {
      this.companyDialog = true
      this.pinVisible = true
    } else {
      this.getPinLength()
      this.pinVisible = true
    }
  },
  mounted () {
    this.$store.dispatch('checkLoginTime')
  },
  computed: {
    setCompany () {
      if (this.company !== undefined) {
        return this.company
      } else {
        return this.$store.getters.company
      }
    },
    url () {
      return this.$store.getters.url
    },
    autosignin () {
      if (this.company && this.emp) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    value: function (val) {
      if (val.length >= this.pinLength) {
        this.submitPin()
      }
    }
  },
  methods: {
    submitPin () {
      if (this.value.length >= this.pinLength) {
        this.unauthorised = false
        this.signingIn = true
        axios.post(this.url + `/tanda-service/getEmpFromPin.ajax.php`, {
          company: this.companyCharcodes ? this.companyCharcodes : this.setCompany,
          pin: (this.emp ? this.pinCharcodes : this.value),
          autosignin: this.autosignin
        })
          .then(response => {
            this.signingIn = false
            if (response.data) {
              localStorage.setItem('clockInFlagLimit', (response.data.clock_in_flag_limit ? response.data.clock_in_flag_limit : -1))
              localStorage.setItem('cancel_hours', (response.data.cancel_hours ? response.data.cancel_hours : -1))
              this.$store.dispatch('setClockInFlagLimit', (response.data.clock_in_flag_limit ? response.data.clock_in_flag_limit : -1))
              localStorage.setItem('clockInLimit', (response.data.clock_in_limit ? response.data.clock_in_limit : -1))
              this.$store.dispatch('setClockInLimit', (response.data.clock_in_limit ? response.data.clock_in_limit : -1))
              localStorage.setItem('clockOutLimit', (response.data.clock_out_limit ? response.data.clock_out_limit : -1))
              localStorage.setItem('jobRecording', (response.data.job_recording ? response.data.job_recording : -1))
              this.$store.dispatch('setClockOutLimit', (response.data.clock_out_limit ? response.data.clock_out_limit : -1))
              this.$store.dispatch('setDisableTimeChangeIn', (response.data.disable_time_change_in ? response.data.disable_time_change_in * 1 === 1 : false))
              this.$store.dispatch('setDisableTimeChangeOut', (response.data.disable_time_change_out ? response.data.disable_time_change_out * 1 === 1 : false))
              console.log(response.data.night_out_ref_type)
              localStorage.setItem('nightOutRefType', (response.data.night_out_ref_type ? response.data.night_out_ref_type : 'number'))
              this.$store.dispatch('setNightOutRefType', (response.data.night_out_ref_type ? response.data.night_out_ref_type : 'number'))
              localStorage.setItem('company', response.data.company)
              this.$store.dispatch('checkCompany', response.data.company)
              if (response.data.empID === -2) {
                this.unauthorised = true
                this.unauthorisedMsg = 'You are not authorised to use T&A. Please contact your system administrator for assistance.'
                this.value = ''
              } else if (response.data.empID !== undefined) {
                firebase.auth().signInWithCustomToken(response.data.token)
                  .then(() => {
                    this.$store.dispatch('signUserIn', response.data)
                    this.$store.dispatch('fetchDisclaimerAccepted')
                    this.$store.dispatch('fetchDisclaimerText')
                    this.$router.push('/')
                  })
                  .catch(error => {
                    console.log(error)
                    this.value = ''
                    this.$store.dispatch('logout')
                    this.$router.push('/')
                  })
              } else {
                this.failedConnection()
              }
            } else {
              this.failedConnection()
            }
          }).catch(() => {
            this.signingIn = false
            firebase.database().ref('appData/recoveryMode').once('value')
              .then((data) => {
                if (data.val() !== true) {
                  this.failedConnection()
                } else {
                  this.recoveryModal = true
                }
              })
              .catch(() => {
                this.failedConnection()
              })
          })
      }
    },
    failedConnection () {
      this.value = ''
      this.unauthorised = true
      this.unauthorisedMsg = 'There was a problem signing in. Please check your internet connection and try again.'
      this.pinVisible = true
    },
    addDigit (digit) {
      this.value += digit
    },
    removeDigit () {
      this.value = this.value.slice(0, -1)
    },
    setCompanyValue () {
      this.$store.dispatch('checkCompany', this.companyValue)
      this.companyDialog = false
      this.getPinLength()
    },
    getPinLength () {
      this.pinVisible = false
      axios.post(this.url + `/tanda-service/getPinLength.ajax.php`, {
        company: this.companyCharcodes ? this.companyCharcodes : this.setCompany
      })
        .then(response => {
          if (response.data.pinLength) {
            this.pinLength = response.data.pinLength * 1
            this.pinVisible = true
          } else {
            this.pinVisible = true
          }
        }).catch(() => {
          this.pinVisible = true
        })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Signin.vue